export const LEFT_HAND_THUMBS_DOWN = [
  {
    t: [-0.0169, 0.0317, -0.0845],
    r: [0.2721, -0.3488, -0.6314, 0.6369],
    s: [1, 1, 1],
  },
  {
    t: [-0.0019, 0.008, -0.1021],
    r: [-0.0533, 0.5043, 0.7891, -0.3467],
    s: [1, 1, 1],
  },
  {
    t: [0.0208, -0.0318, -0.1276],
    r: [-0.2229, 0.6138, 0.7555, 0.0539],
    s: [1, 1, 1],
  },
  {
    t: [0.0282, -0.0578, -0.1318],
    r: [-0.2724, 0.6476, 0.7112, 0.0242],
    s: [1, 1, 1],
  },
  {
    t: [0.0389, -0.0856, -0.1338],
    r: [-0.2724, 0.6476, 0.7112, 0.0242],
    s: [1, 1, 1],
  },
  {
    t: [0.0046, 0.0177, -0.0997],
    r: [0.1919, -0.3993, -0.6438, 0.6238],
    s: [1, 1, 1],
  },
  {
    t: [0.0618, -0.0034, -0.1463],
    r: [-0.1884, 0.0883, -0.6795, 0.7035],
    s: [1, 1, 1],
  },
  {
    t: [0.0481, -0.0093, -0.1821],
    r: [0.6204, -0.5352, 0.4297, -0.3794],
    s: [1, 1, 1],
  },
  {
    t: [0.0275, -0.0094, -0.1746],
    r: [0.6806, -0.6532, 0.2814, -0.176],
    s: [1, 1, 1],
  },
  {
    t: [0.0141, -0.0064, -0.1561],
    r: [0.6806, -0.6532, 0.2814, -0.176],
    s: [1, 1, 1],
  },
  {
    t: [0.0062, 0.0299, -0.1019],
    r: [0.2399, -0.3631, -0.598, 0.6731],
    s: [1, 1, 1],
  },
  {
    t: [0.0621, 0.0218, -0.1466],
    r: [-0.241, 0.1225, -0.6156, 0.7403],
    s: [1, 1, 1],
  },
  {
    t: [0.0427, 0.0133, -0.1823],
    r: [0.7097, -0.4862, 0.373, -0.3475],
    s: [1, 1, 1],
  },
  {
    t: [0.0165, 0.0095, -0.1681],
    r: [0.7968, -0.5892, 0.1321, -0.0209],
    s: [1, 1, 1],
  },
  {
    t: [0.0119, 0.0128, -0.1447],
    r: [0.7968, -0.5892, 0.1321, -0.0209],
    s: [1, 1, 1],
  },
  {
    t: [0.0033, 0.0406, -0.1037],
    r: [0.2574, -0.3085, -0.5681, 0.7183],
    s: [1, 1, 1],
  },
  {
    t: [0.052, 0.0419, -0.1485],
    r: [-0.2306, 0.1278, -0.5499, 0.7925],
    s: [1, 1, 1],
  },
  {
    t: [0.0339, 0.0328, -0.182],
    r: [0.7575, -0.4754, 0.2861, -0.344],
    s: [1, 1, 1],
  },
  {
    t: [0.0099, 0.025, -0.1634],
    r: [0.843, -0.5293, 0.0926, -0.0248],
    s: [1, 1, 1],
  },
  {
    t: [0.0068, 0.0266, -0.142],
    r: [0.843, -0.5293, 0.0926, -0.0248],
    s: [1, 1, 1],
  },
  {
    t: [-0.0018, 0.0508, -0.104],
    r: [0.2798, -0.2351, -0.5355, 0.7614],
    s: [1, 1, 1],
  },
  {
    t: [0.0378, 0.0613, -0.1483],
    r: [-0.1652, 0.0952, -0.5046, 0.842],
    s: [1, 1, 1],
  },
  {
    t: [0.0259, 0.054, -0.1792],
    r: [0.7429, -0.4404, 0.2677, -0.4273],
    s: [1, 1, 1],
  },
  {
    t: [0.0084, 0.0449, -0.169],
    r: [0.8704, -0.4542, 0.1121, -0.1532],
    s: [1, 1, 1],
  },
  {
    t: [0.002, 0.0431, -0.1514],
    r: [0.8704, -0.4542, 0.1121, -0.1532],
    s: [1, 1, 1],
  },
] as const;

export const RIGHT_HAND_THUMBS_DOWN = [
  {
    t: [0.0237, 0.033, -0.083],
    r: [0.325, 0.2979, 0.5612, 0.7004],
    s: [1, 1, 1],
  },
  {
    t: [0.0039, 0.0142, -0.1018],
    r: [0.0744, 0.4501, 0.7672, 0.4508],
    s: [1, 1, 1],
  },
  {
    t: [-0.0239, -0.0191, -0.133],
    r: [0.2089, 0.5732, 0.7915, 0.0363],
    s: [1, 1, 1],
  },
  {
    t: [-0.0341, -0.0435, -0.1401],
    r: [0.2664, 0.6251, 0.7316, 0.0555],
    s: [1, 1, 1],
  },
  {
    t: [-0.0476, -0.0698, -0.144],
    r: [0.2664, 0.6251, 0.7316, 0.0555],
    s: [1, 1, 1],
  },
  {
    t: [-0.0003, 0.0251, -0.0989],
    r: [0.2488, 0.3591, 0.5717, 0.6944],
    s: [1, 1, 1],
  },
  {
    t: [-0.0603, 0.0201, -0.1463],
    r: [-0.2217, -0.1036, 0.5936, 0.7667],
    s: [1, 1, 1],
  },
  {
    t: [-0.045, 0.0116, -0.1809],
    r: [0.681, 0.4806, -0.3657, -0.4143],
    s: [1, 1, 1],
  },
  {
    t: [-0.0253, 0.0071, -0.1724],
    r: [0.7487, 0.5817, -0.2444, -0.2032],
    s: [1, 1, 1],
  },
  {
    t: [-0.0121, 0.0068, -0.1535],
    r: [0.7487, 0.5817, -0.2444, -0.2032],
    s: [1, 1, 1],
  },
  {
    t: [0.001, 0.0374, -0.1005],
    r: [0.2971, 0.3158, 0.527, 0.7309],
    s: [1, 1, 1],
  },
  {
    t: [-0.0548, 0.0447, -0.1454],
    r: [-0.2475, -0.1117, 0.5236, 0.8076],
    s: [1, 1, 1],
  },
  {
    t: [-0.0369, 0.0331, -0.181],
    r: [0.759, 0.413, -0.3155, -0.3922],
    s: [1, 1, 1],
  },
  {
    t: [-0.0126, 0.0231, -0.1665],
    r: [0.8595, 0.4988, -0.1065, -0.0339],
    s: [1, 1, 1],
  },
  {
    t: [-0.0084, 0.0248, -0.1428],
    r: [0.8595, 0.4988, -0.1065, -0.0339],
    s: [1, 1, 1],
  },
  {
    t: [0.0064, 0.0472, -0.1018],
    r: [0.3122, 0.2567, 0.4998, 0.766],
    s: [1, 1, 1],
  },
  {
    t: [-0.0402, 0.0619, -0.1463],
    r: [-0.22, -0.1072, 0.4537, 0.8569],
    s: [1, 1, 1],
  },
  {
    t: [-0.025, 0.0506, -0.1806],
    r: [0.8003, 0.3914, -0.2353, -0.3886],
    s: [1, 1, 1],
  },
  {
    t: [-0.0035, 0.0369, -0.1624],
    r: [0.8979, 0.4322, -0.0728, -0.0395],
    s: [1, 1, 1],
  },
  {
    t: [-0.0008, 0.0373, -0.1409],
    r: [0.8979, 0.4322, -0.0728, -0.0395],
    s: [1, 1, 1],
  },
  {
    t: [0.0136, 0.0558, -0.1017],
    r: [0.3278, 0.1772, 0.4672, 0.8018],
    s: [1, 1, 1],
  },
  {
    t: [-0.0219, 0.0775, -0.1452],
    r: [-0.1811, -0.0932, 0.4016, 0.8929],
    s: [1, 1, 1],
  },
  {
    t: [-0.0108, 0.0677, -0.1758],
    r: [0.7842, 0.3582, -0.2073, -0.4623],
    s: [1, 1, 1],
  },
  {
    t: [0.004, 0.0547, -0.1656],
    r: [0.9158, 0.3542, -0.0821, -0.1706],
    s: [1, 1, 1],
  },
  {
    t: [0.0096, 0.0511, -0.1481],
    r: [0.9158, 0.3542, -0.0821, -0.1706],
    s: [1, 1, 1],
  },
] as const;
